"use client";

import { c as _c } from "react/compiler-runtime";
import { type AITool } from "@app/_metadata";
import { Ident } from "@shared-components/global/ident";
import { Button } from "@shared-components/shadcn/button";
import { CardContent } from "@shared-components/shadcn/card";
import { api } from "@shared-server/api";
import { devEnvironment } from "@shared-utils/environments";
import { env } from "@shared/env.mjs";
import Link from "next/link";
import { useEffect, useState } from "react";
interface AboutContentProps {
  onClose?: () => void;
  aiTool?: AITool;
}
const defaultMeta: AITool = {
  slug: "/",
  tool: false,
  meta: {
    name: "LEO AI",
    description: "AI Tools for LEO Pharma by LEO Pharma",
    byline: "AI & Cloud Data Services",
    contactName: "Alex Schuleit",
    contactEmail: "alscu@leo-pharma.com"
  }
};
export const AboutContent = props => {
  const $ = _c(34);
  const aiTool = props.aiTool || defaultMeta;
  const envQuery = api.utils.env.useQuery();
  const [showReadableVersion, setShowReadableVersion] = useState(true);
  let t0;
  let t1;
  if ($[0] !== envQuery.data) {
    t0 = () => {
      if (envQuery.data && devEnvironment.has(envQuery.data)) {
        setShowReadableVersion(false);
      }
    };
    t1 = [envQuery.data];
    $[0] = envQuery.data;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== props.aiTool) {
    t2 = <Ident invert={true} aiTool={props.aiTool} />;
    $[3] = props.aiTool;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== showReadableVersion) {
    t3 = () => setShowReadableVersion(!showReadableVersion);
    $[5] = showReadableVersion;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = showReadableVersion ? env.NEXT_PUBLIC_VERSION_READABLE : env.NEXT_PUBLIC_VERSION_HASH;
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div><small onClick={t3} className="mt-16 block">{"Version: "}{t4}</small></div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <div className="flex flex-col items-start rounded-t-md bg-primary p-6 text-white">{t2}{t5}</div>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = aiTool?.meta.byline;
  let t8;
  if ($[13] !== t7) {
    t8 = <p className="m-0 mt-1">{t7}</p>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = `Contact: ${aiTool?.meta.contactName}, `;
  const t10 = `mailto:${aiTool?.meta.contactEmail}?subject=${aiTool?.meta.name}`;
  let t11;
  if ($[15] !== aiTool?.meta.contactEmail) {
    t11 = aiTool?.meta.contactEmail?.toLowerCase();
    $[15] = aiTool?.meta.contactEmail;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t11) {
    t12 = <Link className="text-link" href={t10}>{t11}</Link>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t9) {
    t13 = <p className="m-0 text-sm">{t9}{t12}</p>;
    $[20] = t12;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13 || $[24] !== t8) {
    t14 = <div>{t8}{t13}</div>;
    $[23] = t13;
    $[24] = t8;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== props) {
    t15 = props.onClose && <Button onClick={() => props.onClose && props.onClose()}>{"Close"}</Button>;
    $[26] = props;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t14 || $[29] !== t15) {
    t16 = <CardContent className="p-6 pb-8 pt-4"><div className="flex flex-row items-center justify-between">{t14}{t15}</div></CardContent>;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t16 || $[32] !== t6) {
    t17 = <>{t6}{t16}</>;
    $[31] = t16;
    $[32] = t6;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  return t17;
};